<template>
    <!--各地兼职mm群-->
    <div class="regional-groups-page">
        <!-- 头部 -->
        <ZhaiHead />

        <!-- 顶部按钮 -->
        <div class="zhu mb-2">
            <ZhaiTwoTuttons />
        </div>

        <!-- 列表页 -->
        <template v-if="!selectedPost">
            <div class="list-page-wrap" :class="{ 'masked-state': shouldShowListVipMask }">
                <!-- 标题区域 -->
                <div class="container-fluid shengse mb-2">
                    <div class="row shengse">
                        <div class="dixian px-3 py-2 d-flex align-items-center">
                            <i class="fa fa-female LinkIcon"></i>
                            <span class="ms-1">各地兼职mm群</span>
                        </div>
                    </div>
                </div>

                <!-- 列表卡片 -->
                <div class="container-fluid mt-2 px-0">
                    <div class="row card-container">
                        <div
                                class="col-md-4 col-sm-6 mb-2 card-outer"
                                v-for="item in pagedPosts"
                                :key="item.id"
                        >
                            <a
                                    href="#"
                                    class="card-link"
                                    @click.prevent="handleCardClick(item)"
                            >
                                <div class="group-card h-100">
                                    <div class="row g-0 h-100">
                                        <!-- 左侧图片 -->
                                        <div class="col-4 p-0 d-flex align-items-center justify-content-center">
                                            <div class="image-container">
                                                <img :src="item.img" :alt="item.name" class="card-img" />
                                            </div>
                                        </div>

                                        <!-- 右侧内容 -->
                                        <div class="col-8 d-flex flex-column h-100">
                                            <div class="card-body p-2 d-flex flex-column h-100">
                                                <div class="header flex-shrink-0">
                                                    <h5 class="card-title">{{ item.name }}</h5>

                                                    <div class="meta-row mt-2">
                                                        <div class="meta-item">
                                                            <i class="bi bi-clock"></i>
                                                            <span>{{ formatDate(item.createTime) }}</span>
                                                        </div>
                                                        <div class="meta-item">
                                                            <i class="bi bi-eye"></i>
                                                            <span>{{ item.viewCount }}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="content flex-grow-1">
                                                    <p class="card-text">
                                                        {{ item.history }}
                                                    </p>
                                                </div>

                                                <div class="footer flex-shrink-0">
                                                    <span class="region-text">
                                                        {{ item.province }} - {{ item.city }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- 分页 -->
                <div
                        v-if="totalPages > 0"
                        class="bg-white my-2 p-3 text-center d-flex justify-content-center align-items-center pagination-wrap"
                >
                    <button
                            class="custom-page-btn"
                            @click="goFirstPage"
                            :disabled="pageNum === 1"
                    >
                        首页
                    </button>

                    <button
                            class="custom-page-btn"
                            @click="prevPage"
                            :disabled="pageNum === 1"
                    >
                        上一页
                    </button>

                    <span class="page-number-box">{{ pageNum }} / {{ totalPages }}</span>

                    <button
                            class="custom-page-btn next-btn"
                            @click="nextPage"
                            :disabled="pageNum === totalPages"
                    >
                        下一页
                    </button>
                </div>
            </div>

            <!-- 列表页权限弹层：页面一进来就触发 -->
            <div
                    v-if="shouldShowListVipMask"
                    class="vip-mask-overlay list-mask-overlay"
                    @click.self="handleMaskClick"
            >
                <div class="vip-mask-dialog">
                    <!--<button class="vip-close-btn" @click="handleMaskClose">×</button>-->

                    <div class="vip-mask-content">
                        <div class="vip-mask-title">
                            {{ maskTitle }}
                        </div>

                        <div class="vip-mask-text">
                            {{ maskText }}
                        </div>

                        <template v-if="!isLoggedIn">
                            <div class="mask-link-row">
                                <router-link to="/login" class="vip-mask-link-btn">
                                    点击登录
                                </router-link>
                                <router-link to="/register" class="vip-mask-link-btn secondary">
                                    点击注册
                                </router-link>
                            </div>
                        </template>

                        <template v-else>
                            <router-link to="/upgradeVIP" class="vip-upgrade-link">
                                点击升级VIP
                            </router-link>
                        </template>

                        <div class="vip-mask-back" @click="handleMaskClose">
                            返回首页
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- 详情页 -->
        <template v-else>
            <div class="detail-page">
                <div class="detail-card">
                    <div class="detail-title">{{ selectedPost.name }}</div>

                    <div class="detail-user-row">
                        <div class="detail-user-left">
                            <img :src="selectedPost.avatar" class="avatar" alt="头像" />
                            <div class="user-meta">
                                <div class="user-name">{{ selectedPost.author }}</div>
                                <div class="user-date">{{ formatDate(selectedPost.createTime) }}</div>
                            </div>
                        </div>

                        <button class="collect-btn" @click="toggleCollect">
                            <i class="bi" :class="isCollected ? 'bi-heart-fill' : 'bi-heart'"></i>
                            {{ isCollected ? '已收藏' : '收藏' }}
                        </button>
                    </div>

                    <div class="detail-meta-wrap">
                        <div class="detail-meta-item">
                            <span class="detail-meta-label">所属地区：</span>
                            <span>{{ selectedPost.province }} - {{ selectedPost.city }}</span>
                        </div>
                        <div class="detail-meta-item">
                            <span class="detail-meta-label">浏览次数：</span>
                            <span>{{ selectedPost.viewCount }}</span>
                        </div>
                    </div>

                    <div class="detail-gallery">
                        <div
                                class="gallery-item"
                                v-for="(img, index) in selectedPost.gallery"
                                :key="index"
                        >
                            <img :src="img" :alt="selectedPost.name + '-' + (index + 1)" />
                        </div>
                    </div>

                    <div class="detail-content">
                        <p class="detail-paragraph">{{ selectedPost.detail }}</p>
                        <p class="detail-paragraph">{{ selectedPost.notice }}</p>
                        <p class="detail-paragraph">{{ selectedPost.extra }}</p>
                    </div>

                    <div class="copy-share" @click="copyShareText(selectedPost)">
                        复制分享
                    </div>
                </div>

                <div class="back-btn-wrap">
                    <button class="back-btn" @click="backToList">返回</button>
                </div>
            </div>
        </template>

        <!-- 轻提示 -->
        <transition name="fade">
            <div v-if="toast.show" class="toast-box" :class="toast.type">
                <i
                        class="bi me-1"
                        :class="toast.type === 'success' ? 'bi-emoji-smile' : 'bi-emoji-frown'"
                ></i>
                <span>{{ toast.message }}</span>
            </div>
        </transition>

        <!-- 底部 -->
        <ZhaiFoot />
    </div>
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import ZhaiTwoTuttons from "../components/ZhaiTwoTuttons";

    export default {
        name: "MRegionalGroups",
        components: {
            ZhaiHead,
            ZhaiFoot,
            ZhaiTwoTuttons
        },
        data() {
            return {
                pageNum: 1,
                pageSize: 6,
                selectedPost: null,
                isCollected: false,
                toastTimer: null,
                toast: {
                    show: false,
                    message: "",
                    type: "success"
                },
                mockPosts: [
                    {
                        id: 1,
                        name: "深圳兼职群",
                        author: "匿名用户",
                        createTime: "2025-11-03 10:21:00",
                        viewCount: "4万",
                        province: "广东",
                        city: "深圳",
                        history: "近期腾讯风控较严，多数群组暂时失效，管理员正在重新整理入口与分享方式。",
                        detail: "深圳本地兼职信息持续更新中，现阶段群入口正在重新整合，已收集到的新入口会优先同步到可见内容区域。建议关注本页后续变化，避免加入过期群与失效链接。",
                        notice: "本页内容仅供内部整理使用，群内信息请自行甄别，严禁传播虚假信息、引流诈骗与恶意骚扰行为，违者将被平台永久限制访问。",
                        extra: "当前深圳区域更新节奏较快，建议优先查看最近三天内发布的入口信息与补充说明。",
                        img: "https://dummyimage.com/200x260/f1f1f1/333&text=%E6%B7%B1%E5%9C%B3%E5%85%BC%E8%81%8C%E7%BE%A4",
                        avatar: "https://dummyimage.com/80x80/f2c200/ffffff&text=U",
                        gallery: [
                            "https://dummyimage.com/600x420/f5f5f5/333&text=%E6%B7%B1%E5%9C%B3%E7%BE%A4%E5%9B%BE1",
                            "https://dummyimage.com/600x420/ededed/333&text=%E6%B7%B1%E5%9C%B3%E7%BE%A4%E5%9B%BE2",
                            "https://dummyimage.com/600x420/e7e7e7/333&text=%E6%B7%B1%E5%9C%B3%E7%BE%A4%E5%9B%BE3"
                        ]
                    },
                    {
                        id: 2,
                        name: "广州兼职群",
                        author: "匿名用户",
                        createTime: "2025-11-04 13:18:00",
                        viewCount: "2.3万",
                        province: "广东",
                        city: "广州",
                        history: "广州本地资源正在更新，原入口已失效，等待新群重新开放。",
                        detail: "广州区域目前已重新回收部分旧入口，新的分享节点仍在补充中。平台会筛掉明显异常账号与疑似营销号，再放出新的查看内容。",
                        notice: "查看群信息前请先确认自己的用途与风险判断，不建议随意向陌生账号透露联系方式、位置与付款信息。",
                        extra: "广州区域近期新增了多个临时过渡群，入口有效时间较短，请留意更新时间。",
                        img: "https://dummyimage.com/200x260/ececec/333&text=%E5%B9%BF%E5%B7%9E%E5%85%BC%E8%81%8C%E7%BE%A4",
                        avatar: "https://dummyimage.com/80x80/f2c200/ffffff&text=U",
                        gallery: [
                            "https://dummyimage.com/600x420/f5f5f5/333&text=%E5%B9%BF%E5%B7%9E%E7%BE%A4%E5%9B%BE1",
                            "https://dummyimage.com/600x420/ededed/333&text=%E5%B9%BF%E5%B7%9E%E7%BE%A4%E5%9B%BE2",
                            "https://dummyimage.com/600x420/e5e5e5/333&text=%E5%B9%BF%E5%B7%9E%E7%BE%A4%E5%9B%BE3"
                        ]
                    },
                    {
                        id: 3,
                        name: "上海兼职群",
                        author: "匿名用户",
                        createTime: "2025-11-05 08:09:00",
                        viewCount: "3.6万",
                        province: "上海",
                        city: "上海",
                        history: "上海兼职资源较多，正在做入口筛选与可用性整理。",
                        detail: "上海地区的资源密度较高，群入口变动频繁。平台已对近期回传内容做二次整理，后续会持续更新高活跃度入口。",
                        notice: "遇到要求提前转账、担保费、押金、认证费等场景，请立刻退出，谨防被骗。",
                        extra: "当前上海区域有多个细分方向群，查看前先确认自己的实际需求，避免重复加入。",
                        img: "https://dummyimage.com/200x260/f0f0f0/333&text=%E4%B8%8A%E6%B5%B7%E5%85%BC%E8%81%8C%E7%BE%A4",
                        avatar: "https://dummyimage.com/80x80/f2c200/ffffff&text=U",
                        gallery: [
                            "https://dummyimage.com/600x420/f5f5f5/333&text=%E4%B8%8A%E6%B5%B7%E7%BE%A4%E5%9B%BE1",
                            "https://dummyimage.com/600x420/eeeeee/333&text=%E4%B8%8A%E6%B5%B7%E7%BE%A4%E5%9B%BE2",
                            "https://dummyimage.com/600x420/e8e8e8/333&text=%E4%B8%8A%E6%B5%B7%E7%BE%A4%E5%9B%BE3"
                        ]
                    }
                ]
            };
        },
        computed: {
            totalPages() {
                return Math.ceil(this.mockPosts.length / this.pageSize) || 1;
            },
            pagedPosts() {
                const start = (this.pageNum - 1) * this.pageSize;
                const end = start + this.pageSize;
                return this.mockPosts.slice(start, end);
            },

            isLoggedIn() {
                const getters = this.$store?.getters || {};
                if (typeof getters.isLoggedIn === "boolean") return getters.isLoggedIn;
                return false;
            },
            getUser() {
                const getters = this.$store?.getters || {};
                return getters.getUser || null;
            },
            isPermanentVip() {
                if (!this.isLoggedIn) return false;
                const level = String(this.getUser?.level || "").trim();
                return level.includes("永久会员") || level.includes("永久至尊VIP");
            },
            canViewRegionalGroups() {
                return this.isLoggedIn && this.isPermanentVip;
            },

            /*
             * 保持原逻辑：
             * 列表页一出现就判断
             * 不是永久会员，就直接显示列表页遮罩
             */
            shouldShowListVipMask() {
                return !this.selectedPost && !this.canViewRegionalGroups;
            },

            maskTitle() {
                return this.isLoggedIn ? "您没有权限访问" : "请先登录后查看";
            },
            maskText() {
                return this.isLoggedIn
                    ? "此内容只有永久至尊VIP才能查看！"
                    : "登录或注册后才可继续访问该内容。";
            }
        },
        methods: {
            formatDate(value) {
                if (!value) return "";
                return String(value).slice(0, 10);
            },

            goFirstPage() {
                this.pageNum = 1;
                this.scrollTop();
            },
            prevPage() {
                if (this.pageNum > 1) {
                    this.pageNum--;
                    this.scrollTop();
                }
            },
            nextPage() {
                if (this.pageNum < this.totalPages) {
                    this.pageNum++;
                    this.scrollTop();
                }
            },

            handleCardClick(post) {
                if (!this.canViewRegionalGroups) {
                    this.showToast(this.isLoggedIn ? "仅永久会员可查看" : "请先登录", "error");
                    return;
                }

                this.selectedPost = JSON.parse(JSON.stringify(post));
                this.isCollected = false;
                this.scrollTop();
            },

            backToList() {
                this.selectedPost = null;
                this.isCollected = false;
                this.scrollTop();
            },

            handleMaskClick() {
                // 点遮罩空白区域不做跳转，保持当前列表页
            },

            handleMaskClose() {
                this.$router.push('/');
            },
            scrollTop() {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            },

            toggleCollect() {
                if (!this.isLoggedIn) {
                    this.showToast("请先登录", "error");
                    return;
                }
                this.isCollected = !this.isCollected;
                this.showToast(this.isCollected ? "收藏成功" : "已取消收藏", "success");
            },

            async copyShareText(post) {
                if (!this.canViewRegionalGroups) {
                    this.showToast("当前无权限复制内容", "error");
                    return;
                }

                const text =
                    `${post.name}\n` +
                    `发布时间：${this.formatDate(post.createTime)}\n` +
                    `地区：${post.province}-${post.city}\n` +
                    `${post.detail}\n` +
                    `${post.notice}\n` +
                    `${post.extra}`;

                try {
                    if (navigator.clipboard && window.isSecureContext) {
                        await navigator.clipboard.writeText(text);
                    } else {
                        const textarea = document.createElement("textarea");
                        textarea.value = text;
                        textarea.style.position = "fixed";
                        textarea.style.left = "-9999px";
                        textarea.style.top = "0";
                        document.body.appendChild(textarea);
                        textarea.focus();
                        textarea.select();
                        document.execCommand("copy");
                        document.body.removeChild(textarea);
                    }
                    this.showToast("已复制分享内容", "success");
                } catch (e) {
                    this.showToast("复制失败，请手动复制", "error");
                }
            },

            showToast(message, type = "success") {
                this.toast.show = true;
                this.toast.message = message;
                this.toast.type = type;

                if (this.toastTimer) {
                    clearTimeout(this.toastTimer);
                }

                this.toastTimer = setTimeout(() => {
                    this.toast.show = false;
                }, 2000);
            }
        },
        beforeUnmount() {
            if (this.toastTimer) {
                clearTimeout(this.toastTimer);
                this.toastTimer = null;
            }
        }
    };
</script>

<style scoped>
    .regional-groups-page {
        background: #f5f5f5;
        min-height: 100vh;
    }

    .zhu {
        margin-top: 80px;
    }

    .list-page-wrap {
        position: relative;
        transition: all 0.2s ease;
    }

    .masked-state .card-container,
    .masked-state .pagination-wrap,
    .masked-state .shengse {
        filter: blur(3px);
        user-select: none;
        pointer-events: none;
    }

    /* 标题区域 */
    .dixian {
        background: #ffffff;
        border-bottom: 1px solid #efefef;
        color: #222;
        font-size: 1rem;
    }

    /* 列表区 */
    .card-container {
        display: flex;
        flex-wrap: wrap;
        margin-left: 0;
        margin-right: 0;
    }

    .card-outer {
        padding-left: 6px;
        padding-right: 6px;
        display: flex;
    }

    .card-link {
        width: 100%;
        text-decoration: none;
        color: inherit;
    }

    .group-card {
        width: 100%;
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #f0f0f0;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .group-card:active {
        transform: scale(0.995);
    }

    .image-container {
        width: 100px;
        height: 130px;
        margin: 12px auto;
        border-radius: 6px;
        overflow: hidden;
        background: #f3f3f3;
    }

    .card-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .card-body {
        min-height: 154px;
    }

    .card-title {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #222;
        line-height: 1.4;
    }

    .meta-row {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .meta-item {
        display: flex;
        align-items: center;
        color: #999;
        font-size: 13px;
    }

    .meta-item i {
        margin-right: 4px;
    }

    .content {
        margin-top: 10px;
    }

    .card-text {
        margin-bottom: 10px;
        font-size: 14px;
        color: #666;
        line-height: 1.7;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .footer {
        margin-top: auto;
    }

    .region-text {
        display: inline-block;
        font-size: 14px;
        color: #18b371;
    }

    /* 分页 */
    .pagination-wrap {
        gap: 12px;
        flex-wrap: wrap;
    }

    .custom-page-btn {
        min-width: 88px;
        height: 42px;
        border: 1px solid #dcdcdc;
        background: #fff;
        border-radius: 8px;
        color: #555;
        font-size: 15px;
        cursor: pointer;
    }

    .custom-page-btn:disabled {
        color: #bbb;
        border-color: #e9e9e9;
        cursor: not-allowed;
        background: #fafafa;
    }

    .page-number-box {
        min-width: 110px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        border: 1px solid #dcdcdc;
        background: #fff;
        border-radius: 8px;
        font-size: 15px;
        color: #555;
    }

    .next-btn {
        border-color: #9ed56a;
    }

    /* 列表权限弹层 */
    .vip-mask-overlay {
        position: fixed;
        inset: 0;
        z-index: 3000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        overflow: hidden;
    }

    /* 只改列表页一进入时的背景图 */
    .list-mask-overlay {
        background: url("@/assets/weiqunjietu.png") center center / cover no-repeat;
    }

    .list-mask-overlay::before {
        content: "";
        position: absolute;
        inset: 0;
        background: rgba(255, 255, 255, 0.18);
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
    }

    .vip-mask-dialog {
        position: relative;
        width: 100%;
        max-width: 360px;
        min-height: 320px;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: none;
        background: transparent;
        z-index: 1;
    }


    .vip-close-btn {
        position: absolute;
        top: 12px;
        left: 14px;
        width: 32px;
        height: 32px;
        border: none;
        background: transparent;
        font-size: 32px;
        line-height: 28px;
        color: #8a8a8a;
        cursor: pointer;
        z-index: 2;
    }

    .vip-mask-content {
        min-height: 320px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 54px 26px 32px;
        text-align: center;
        background: transparent;
    }
    .vip-mask-title {
        font-size: 20px;
        line-height: 1.8;
        color: #111;
        margin-bottom: 8px;
        font-weight: 500;
    }

    .vip-mask-text {
        font-size: 18px;
        line-height: 1.9;
        color: #222;
        margin-bottom: 22px;
        max-width: 260px;
    }

    .mask-link-row {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: 22px;
    }

    .vip-mask-link-btn {
        min-width: 112px;
        height: 40px;
        line-height: 40px;
        padding: 0 18px;
        border-radius: 20px;
        background: #18b371;
        color: #fff;
        text-decoration: none;
        font-size: 15px;
    }

    .vip-mask-link-btn.secondary {
        background: #52a7ff;
    }

    .vip-upgrade-link {
        color: #3aa0ff;
        font-size: 18px;
        text-decoration: none;
        margin-bottom: 24px;
    }

    .vip-mask-back {
        color: #3aa0ff;
        font-size: 18px;
        cursor: pointer;
    }

    /* 详情页 */
    .detail-page {
        padding: 12px;
    }

    .detail-card {
        background: #fff;
        border-radius: 4px;
        overflow: hidden;
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
    }

    .detail-title {
        font-size: 24px;
        font-weight: 700;
        color: #111;
        padding: 18px 18px 8px;
        line-height: 1.5;
    }

    .detail-user-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 18px 0;
        gap: 12px;
    }

    .detail-user-left {
        display: flex;
        align-items: center;
        min-width: 0;
    }

    .avatar {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-right: 14px;
        object-fit: cover;
        flex-shrink: 0;
    }

    .user-meta {
        min-width: 0;
    }

    .user-name {
        font-size: 16px;
        color: #666;
        margin-bottom: 4px;
    }

    .user-date {
        font-size: 14px;
        color: #b0b0b0;
    }

    .collect-btn {
        height: 36px;
        padding: 0 14px;
        border: 1px solid #ff9c42;
        color: #ff9c42;
        background: #fff;
        border-radius: 18px;
        font-size: 14px;
        white-space: nowrap;
    }

    .collect-btn i {
        margin-right: 4px;
    }

    .detail-meta-wrap {
        padding: 14px 18px 6px;
    }

    .detail-meta-item {
        font-size: 15px;
        color: #666;
        line-height: 1.9;
    }

    .detail-meta-label {
        color: #333;
        font-weight: 600;
    }

    .detail-gallery {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
        padding: 16px 18px 0;
    }

    .gallery-item {
        width: 100%;
        border-radius: 8px;
        overflow: hidden;
        background: #f3f3f3;
        border: 1px solid #eee;
    }

    .gallery-item img {
        width: 100%;
        height: 160px;
        object-fit: cover;
        display: block;
    }

    .detail-content {
        padding: 20px 18px 24px;
        font-size: 17px;
        line-height: 2;
        color: #666;
        min-height: 180px;
    }

    .detail-paragraph {
        margin-bottom: 16px;
        text-indent: 2em;
    }

    .copy-share {
        text-align: center;
        color: #1e90ff;
        font-size: 18px;
        padding: 18px 0 24px;
        border-top: 1px solid #f1f1f1;
        cursor: pointer;
    }

    .back-btn-wrap {
        text-align: center;
        margin-top: 16px;
    }

    .back-btn {
        min-width: 120px;
        height: 44px;
        border: none;
        background: #9fd36b;
        color: #fff;
        border-radius: 8px;
        font-size: 16px;
        cursor: pointer;
    }

    /* Toast */
    .toast-box {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
        min-width: 160px;
        max-width: 280px;
        padding: 10px 16px;
        border-radius: 10px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
    }

    .toast-box.success {
        background: rgba(0, 194, 111, 0.95);
    }

    .toast-box.error {
        background: rgba(220, 53, 69, 0.95);
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    /* 响应式 */
    @media (max-width: 768px) {
        .zhu {
            margin-top: 80px;
        }

        .card-title {
            font-size: 16px;
        }

        .detail-title {
            font-size: 20px;
        }

        .detail-content {
            font-size: 16px;
        }

        .gallery-item img {
            height: 130px;
        }

        .vip-mask-title {
            font-size: 18px;
        }

        .vip-mask-text {
            font-size: 16px;
        }

        .vip-upgrade-link,
        .vip-mask-back {
            font-size: 16px;
        }
    }
</style>
